/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Vehicle_No_ActivityInputs */

const fr_vehicle_no_activity = /** @type {(inputs: Vehicle_No_ActivityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ce véhicule n'a pas encore été observé en service commercial.`)
};

const en_vehicle_no_activity = /** @type {(inputs: Vehicle_No_ActivityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This vehicle has not been observed in commercial service yet.`)
};

/**
* | output |
* | --- |
* | "This vehicle has not been observed in commercial service yet." |
*
* @param {Vehicle_No_ActivityInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const vehicle_no_activity = /** @type {((inputs?: Vehicle_No_ActivityInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Vehicle_No_ActivityInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_vehicle_no_activity(inputs)
	return en_vehicle_no_activity(inputs)
});